import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useLocation } from "react-router-dom";
import { Menu, Popover } from "antd";
import { injectIntl, FormattedMessage } from "react-intl";
import { logout } from "../../actions/UserActions";
import { Auth } from "../../services/Auth";
import { RoutePath } from "../../constants/SitePaths";
import Can from "../../services/permisions/Can";
import RolesHelper from "../../services/permisions/RolesHelper";

function AccountMenu({ intl }) {
	const user = useSelector(state => state.user);
	const dispatch = useDispatch();
	const location = useLocation();

	const menuSections = {
		dashboard: { url: RoutePath.PROJECTS },
		profile: { url: RoutePath.PROFILE },
		roles: { url: RoutePath.ROLES },
		users: { url: RoutePath.USERS },
		companies: { url: RoutePath.COMPANIES },
		requests: { url: RoutePath.REQUESTS },
	};
	const selectedKeys = Object.keys(menuSections)
		.filter(item => location.pathname.match(`^${menuSections[item].url}`))
		.map(item => menuSections[item].url);
	const menu = (
		<Menu defaultSelectedKeys={[location.pathname]} selectedKeys={selectedKeys}>
			{!RolesHelper.isAffilateUser() && (
				<Menu.Item key={menuSections.dashboard.url}>
					<Link to={menuSections.dashboard.url}>
						<FormattedMessage id="dashboard" />
					</Link>
				</Menu.Item>
			)}
			{Can({
				I: "view",
				a: "userManagement.userMyProfile",
				children: true,
				fallback: false,
			}) && (
				<Menu.Item key={menuSections.profile.url}>
					<Link to={menuSections.profile.url}>
						<FormattedMessage id="my_profile" />
					</Link>
				</Menu.Item>
			)}
			{Can({
				I: "view",
				a: "userManagement.userRoles",
				children: true,
				fallback: false,
			}) && (
				<Menu.Item key={menuSections.roles.url}>
					<Link to={menuSections.roles.url}>
						<FormattedMessage id="roles" />
					</Link>
				</Menu.Item>
			)}
			{Can({
				I: "view",
				a: "SuperAdmin",
				children: true,
				fallback: false,
			}) && (
				<Menu.Item key={menuSections.companies.url}>
					<Link to={menuSections.companies.url}>
						<FormattedMessage id="companies" />
					</Link>
				</Menu.Item>
			)}
			{Can({
				I: "view",
				a: "userManagement.userUsers",
				children: true,
				fallback: false,
			}) && (
				<Menu.Item key={menuSections.users.url}>
					<Link to={menuSections.users.url}>
						<FormattedMessage id="users" />
					</Link>
				</Menu.Item>
			)}
			{(Can({
				I: "view",
				a: "userManagement.userRequests",
				children: true,
				fallback: false,
			}) ||
				user.superAdmin) && (
				<Menu.Item key={menuSections.requests.url}>
					<Link to={menuSections.requests.url}>
						<FormattedMessage id="requests" />
					</Link>
				</Menu.Item>
			)}

			<Menu.Item>
				<a
					onClick={() => {
						dispatch(logout());
					}}
				>
					<FormattedMessage id="logout" />
				</a>
			</Menu.Item>
		</Menu>
	);

	if (!user.isLoggedIn && !Auth.isAuthenticated()) {
		return <Navigate to="/login" replace />;
	}

	return (
		!RolesHelper.isAffilateUser() && (
			<div className="tb--flex tb--align-center header-right-actions">
				{/* {showName && !isSettingsHeader ? <div className='tb--mh-16'>{this.props.user.firstName} {this.props.user.lastName}</div> : <></>} */}
				<a href={intl.messages.help_hint} target="_blank" className="cyrcle-outline tb--mr-18" rel="noreferrer">
					<i className="question-bicon" />
				</a>
				<Popover
					key={location.pathname}
					placement="bottom"
					title={`${user.firstName || ""} ${user.lastName || ""}`}
					content={menu}
					trigger={["click"]}
				>
					<a className="cyrcle">
						<i className="user-bicon" />
					</a>
				</Popover>
			</div>
		)
	);
}

export default injectIntl(AccountMenu);
